module.exports = __webpack_public_path__ + "img/07.dff3eeb7.jpg";